module.exports = __webpack_public_path__ + "img/logo.273b9129.png";